import { ReactNode } from "react"
import { css, cx } from "@emotion/css"

const cn = css`
  text-align: center !important;
  display: table-caption;
  font-size: 1rem !important;
  font-weight: 400 !important;
  color: var(--dark-grey) !important;
  padding: 0px !important;
`

export type EmptyBodyProps = {
  className?: string
  children?: ReactNode
}

export function EmptyBody(props: EmptyBodyProps) {
  const { className, children = "no results found" } = props

  return <caption className={cx(cn, className)}>{children}</caption>
}
